"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/render/canvas/BuilderType
 */

/**
 * @enum {string}
 */
var _default = {
  CIRCLE: 'Circle',
  DEFAULT: 'Default',
  IMAGE: 'Image',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon',
  TEXT: 'Text'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2JBLE1BQU0sRUFBRSxRQURLO0VBRWJDLE9BQU8sRUFBRSxTQUZJO0VBR2JDLEtBQUssRUFBRSxPQUhNO0VBSWJDLFdBQVcsRUFBRSxZQUpBO0VBS2JDLE9BQU8sRUFBRSxTQUxJO0VBTWJDLElBQUksRUFBRTtBQU5PLEMiLCJuYW1lcyI6WyJDSVJDTEUiLCJERUZBVUxUIiwiSU1BR0UiLCJMSU5FX1NUUklORyIsIlBPTFlHT04iLCJURVhUIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZW5kZXIvY2FudmFzL0J1aWxkZXJUeXBlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19